<div class="ui accordion">
  <div class="title">
    <i class="dropdown icon"></i>
    {{name}}
  </div>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>